export const bigIntToString = (value: bigint) => {
  return `${value.toString()}n`;
};

export const stringToBigInt = (value: string) => {
  if (/^\d+n$/.test(value)) {
    return BigInt(value.slice(0, -1));
  }

  return BigInt(0);
};
